/*
 *
 * WalletDetailsPage constants
 *
 */

const BASE_ACTION_CONSTANT = 'app/walletDetailsPage';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const GET_WALLET_STATUS = `${BASE_ACTION_CONSTANT}/GET_WALLET_STATUS`;

export const GET_WALLET_BALANCE = `${BASE_ACTION_CONSTANT}/GET_WALLET_BALANCE`;

export const UPDATE_WALLET_BALANCE = `${BASE_ACTION_CONSTANT}/UPDATE_WALLET_BALANCE`;

export const UPDATE_WALLET_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_WALLET_STATUS`;

export const FETCH_WALLET_HISTORY_DATA = `${BASE_ACTION_CONSTANT}/FETCH_WALLET_HISTORY_DATA`;

export const ADD_MONEY_TO_WALLET = `${BASE_ACTION_CONSTANT}/ADD_MONEY_TO_WALLET`;

export const MODIFY_WALLET_STATUS = `${BASE_ACTION_CONSTANT}/MODIFY_WALLET_STATUS`;

export const SAVE_WALLET_HISTORY_DATA = `${BASE_ACTION_CONSTANT}/SAVE_WALLET_HISTORY_DATA`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/EABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const UPDATE_BANK_DETAILS = `${BASE_ACTION_CONSTANT}/UPDATE_BANK_DETAILS`;

export const EXPORT_TO_CSV = `${BASE_ACTION_CONSTANT}/EXPORT_TO_CSV`;

export const FETCH_WALLET_HISTORY_DATA_URL = {
  url: '/pg/refunds/wallets/ledger',
  method: 'GET',
};

export const FETCH_FEE_WALLET_HISTORY_DATA_URL = {
  url: '/common/fee-wallets/ledger',
  method: 'GET',
};

export const FETCH_DISPUTE_WALLET_HISTORY_DATA_URL = {
  url: '/pg/settlements/merchant-beneficiaries/search',
  method: 'GET',
};

export const ADD_MONEY_TO_FEE_WALLET_URL = {
  url: '/common/fee-wallets/recharge-mode',
  method: 'GET',
};

export const GET_FEE_WALLET_STATUS_URL = {
  url: '/common/fee-wallets/reference',
  method: 'GET',
};

export const GET_WALLET_BALANCE_URL = {
  url: '/pg/refunds/wallets/balance',
  method: 'GET',
};

export const MODIFY_WALLET_STATUS_URL = {
  url: '/pg/refunds/wallets/reference',
  method: 'PATCH',
};

export const WALLET_TYPE_KEY_MAPPING = {
  refundWallet: 'refund',
  freeWallet: 'free',
};

export const WALLET_TABLE_HEADINGS = [
  {
    key: 'txTime',
    displayName: 'Date & Time',
  },
  {
    key: 'eventType',
    displayName: 'Event',
  },
  {
    key: 'refundId',
    displayName: 'Event ID',
  },
  {
    key: 'utr',
    displayName: 'UTR',
  },
  {
    key: 'saleType',
    displayName: 'Sale Type',
  },
  {
    key: 'amount',
    displayName: 'Amount',
  },
  {
    key: 'closingBalance',
    displayName: 'Closing Balance',
    align: 'right',
  },
];

export const DATA_MAPPER = {
  addedOn: 'Date & Time',
  event: 'Event',
  eventId: 'Event Id',
  utr: 'UTR',
  saleType: 'Sale Type',
  amount: 'Amount',
  closingBalance: 'Closing Balance',
};

export const PG_REFUND = 'pg_refund';

export const REFUND_ID_INFO_TEXT =
  'Event Id is Refund Id in case of Refund and Recharge Id in case of Recharge.';

export const INVOICINGSVC = 'invoicingsvc';

export const FEE = 'fee';

export const REFUND = 'refund';

export const DISPUTE = 'dispute';

export const MIN_BALANCE_AMOUNT = 5000;

export const IN_ACTIVE = 'IN_ACTIVE';
